module.exports = __webpack_public_path__ + "img/icons B_34.d30bfd39.png";